<div class="col-md-12 pageTitle">
  <label class="pt-4 pl-4">Clinic Repayment Details</label>
</div>
<div class="col-md-12 mt-3">
  <div class="row">
    <div class="col-md-2">
      <ng-select [items]="clinicList" bindLabel="name" [clearable]="false" [addTag]="false" [multiple]="false"
        placeholder="Select Clinic" (change)="onClinicChange($event)" [(ngModel)]="clinic_selected">
      </ng-select>
    </div>
    <div class="col-md-2 offset-md-6">
      <button class="btn btn-success button" *ngIf="isEditEnabled" (click)="exportAsXLSX()"><em
          class="fa fa-share"></em>&nbsp;&nbsp;&nbsp;
        Export to Excel</button>
    </div>
    <div class="col-md-2">
      <my-date-range-picker name="mydaterange" class="float-right ml-4" [options]="myDateRangePickerOptions"
        [(ngModel)]="dateRange" required (dateRangeChanged)="changeDate($event)">
      </my-date-range-picker>
    </div>
  </div>
  <div class="table-responsive pl-10 pr-10">
    <table class="table table-hover table-bordered">
      <thead class="turTable">
        <tr>
          <th class="cellHeader">Date</th>
          <th class="cellHeader">Clinic Name</th>
          <th class="cellHeader text-center">Total app transaction</th>
          <th class="cellHeader text-center">Inclinic app transaction</th>
          <th class="cellHeader text-center">Payment Gateway Charge</th>
          <th class="cellHeader text-center">Phone call app transaction</th>
          <th class="cellHeader text-center">Phone Consultation Charge with GST</th>
          <th class="cellHeader text-center">Settlement Amount</th>
          <th class="cellHeader text-center">Status</th>
          <th class="cellHeader text-center action" *ngIf="isEditEnabled">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of repaymentList">
          <td class="cellValue">{{item?.date | date:'dd-MM-yyyy'}}</td>
          <td class="cellValue">{{item?.clinic?.name}}</td>
          <td class="cellValue text-center">
            {{item?.total_online_amount | currency : 'INR' : 'symbol-narrow' : '1.0-2' || '0'}}</td>
          <td class="cellValue text-center">{{item?.online_due | currency : 'INR' : 'symbol-narrow' : '1.0-2' || '0'}}
          </td>
          <td class="cellValue text-center">&#8377;{{item?.gateway_charges || 0}}</td>
          <td class="cellValue text-center">
            {{item?.total_phone_consultation_amount | currency : 'INR' : 'symbol-narrow' : '1.0-2' || '0'}}</td>
          <td class="cellValue text-center">
            {{item?.total_phone_consultation_due | currency : 'INR' : 'symbol-narrow' : '1.0-2' || '0'}}</td>
          <td class="cellValue text-center">
            {{item?.total_online_due | currency : 'INR' : 'symbol-narrow' : '1.0-2' || '0'}}</td>
          <td class="cellValue text-center" *ngIf="item.payment_details && item.payment_details.is_payment_done">
            Paid On {{item?.payment_details?.payment_date | date:'dd-MM-yyyy'}}</td>
          <td class="cellValue text-center" *ngIf="!item.payment_details || !item.payment_details.is_payment_done">Yet
            To Pay</td>
          <td class="cellValue text-center action" *ngIf="isEditEnabled">
            <button class="payBlue btn" (click)="updatePayment(item)"
              *ngIf="!item?.payment_details?.is_payment_done">Pay</button>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent($event)">
  </mat-paginator>
</div>
